import React from "react"
import {DrawerProps as MuiDrawerProps} from "@mui/material"
import {breakpoints} from "@next/ux-fabric"
import {useMediaQuery} from "../../../../hooks/useMediaQuery"
import {DrawerContainer} from "./component"

export type DrawerProps = Pick<MuiDrawerProps, "open" | "anchor" | "children"> & {
    onClose: () => void
    text: any
    showCloseIcon: boolean
    realm: string
    variant: string
    iconsVersionPath: string
}

const StandardDrawerContainer = ({anchor, open, onClose, children}: DrawerProps) => {
    const shouldDisableScrollLock = useMediaQuery(`(min-width:${breakpoints.values.md}px)`)

    const modalProps = {
        keepMounted: false,
        disableRestoreFocus: true,
        disableAutoFocus: true,
        disableEnforceFocus: true,
        closeAfterTransition: false,
        disablePortal: true,
        disableScrollLock: shouldDisableScrollLock,
        hideBackdrop: false,
    }

    return (
        <DrawerContainer className="drawer" anchor={anchor} open={open} onClose={onClose} ModalProps={modalProps}>
            {children}
        </DrawerContainer>
    )
}

export default StandardDrawerContainer
